<template lang="pug">
  sui-container
    transition(name="fade")
      sui-dimmer(
        inverted,
        active,
        v-if="loading")
        sui-loader Loading...

    match-score(
      v-if="!loading",
      :teams="teams",
      :scores="match.scores")

    games-menu(
      :games="games",
      v-model="selected")

    games-score-table(
      v-if="!loading && selected === 0",
      :games="match.games",
      :teams="teams")

    game-score(
      v-if="!loading && selectedGame",
      :map="unslugify(selectedGame.map)",
      :teams="teams",
      :scores="selectedGame.points")

    nav-menu(
      :options="typeOptions",
      v-model="type")

    div
      sui-message(
        v-if="official",
        icon="exclamation triangle",
        header="Inaccurate stats",
        :content="warning",
        warning)

    player-stats(
      v-if="!loading",
      :games="selectedGame ? [selectedGame] : games",
      :teams="teams",
      :players="players",
      :display="type")
</template>

<script>
import stringsUtil from '@/utils/strings';

import NavMenu from '@/components/NavMenu.vue';

import GamesMenu from '@/components/match/GamesMenu.vue';
import GamesScoreTable from '@/components/match/GamesScoreTable.vue';
import MatchScore from '@/components/match/MatchScore.vue';

import GameScore from '@/components/game/GameScore.vue';
import PlayerStats from '@/components/game/PlayerStats.vue';

export default {
  name: 'Match',
  components: {
    NavMenu,
    GamesMenu,
    GamesScoreTable,
    MatchScore,
    GameScore,
    PlayerStats,
  },
  data() {
    return {
      games: [],
      gamesLoading: false,
      selected: 0,
      typeOptions: [
        {
          name: 'Stats Table',
          key: 'table',
        },
        {
          name: 'Compare',
          key: 'compare',
        },
        {
          name: 'Chart',
          key: 'chart',
        },
      ],
      type: 'table',
      warning:
        'The stats displayed is fetched from an in development API. It most probably be inaccurate.',
    };
  },
  created() {
    this.initStuff();
  },
  computed: {
    matchId() {
      return Number(this.$route.params.matchId) || 0;
    },
    match() {
      return this.$store.state.matches.find(x => x.matchId === this.matchId);
    },
    teams() {
      if (!this.match) {
        return [];
      }

      const teams = this.$store.state.teams.filter(x => this.match.teams.includes(x.teamId));
      return this.match.teams.map(teamId => teams.find(x => x.teamId === teamId));
    },
    players() {
      if (!this.teams.length) {
        return [];
      }

      if (!this.games.length) {
        return [];
      }

      const playerIds = this.games
        .filter(game => game.seenPlayers)
        .reduce((acc, game) => acc.concat([...game.seenPlayers[0], ...game.seenPlayers[1]]), []);

      return this.$store.state.players.filter(x => playerIds.includes(x.playerId));
    },
    storeLoading() {
      return this.$store.state.loading;
    },
    loading() {
      return this.storeLoading || this.gamesLoading;
    },
    selectedGame() {
      return this.games.find(x => x.gameId === this.selected);
    },
    official() {
      return this.games.reduce((acc, game) => acc || game.official, false);
    },
  },
  methods: {
    initStuff() {
      if (!this.storeLoading && !this.match) {
        this.$router.replace({ name: 'matches' });
      }

      if (!this.storeLoading) {
        this.fetchGames();
      }
    },
    async fetchGames() {
      this.gamesLoading = true;

      const gamePromises = this.match.games.map(game =>
        fetch(`${process.env.VUE_APP_API_BASE_URL}/games/${game.gameId}.json`),
      );

      const gameResponses = await Promise.all(gamePromises);
      let games = await Promise.all(
        gameResponses.map(x => x.json().catch(() => console.log('game not found'))),
      );
      games = games.filter(x => x);

      this.games = this.match.games.map(game => ({
        ...game,
        ...games.find(x => x.gameId === game.gameId),
      }));

      this.gamesLoading = false;
    },
    unslugify: stringsUtil.unslugify,
  },
  watch: {
    storeLoading() {
      this.initStuff();
    },
    selected() {
      this.type = 'table';
    },
  },
};
</script>
